<div class="dbms-container">
<!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Loading DMS...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="loadError" class="error-container">
    <mat-icon color="warn">error</mat-icon>
    <h3>Failed to Load DMS</h3>
    <p>{{ loadError }}</p>
    <button mat-raised-button color="primary" (click)="retry()">
      <mat-icon>refresh</mat-icon>
      Retry
    </button>
  </div>

  <!-- DBMS Iframe -->
  <div class="iframe-container" [class.hidden]="isLoading || loadError">
    <iframe
      #ydFrame
      *ngIf="iframeSrc"
      [src]="iframeSrc"
      (load)="onIframeLoad()"
      frameborder="0"
      allow="clipboard-read; clipboard-write"
      sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-downloads">
    </iframe>
  </div>
</div>

